module.exports = __webpack_public_path__ + "img/Med05.05-3-CWM2018-0037-0050-Dm.0224c733.jpg";